import React, { Component } from 'react';
import './Input.css';

class FileInput extends Component {
  state = {
      file: null,
      isLoaded: false
  }
  handleFile = (event) => {
    this.setState({
      file: this.fileInput.files[0],
      isLoaded: true
    })
  }

  removeFile = (event) => {
    this.setState({
      file: null,
      isLoaded: false
    })
    this.fileInput.value = ''
  }
  render() {
    const {
      id: idInput = '0',
      label: fileLabel = 'загрузите файл'
    } = this.props;
    return (
      <div className={`input input--flex ${this.props.modifier ? this.props.modifier : ''}`}>
        {
          !this.state.isLoaded &&
          "или"
        }
        <input
          key="file-upload"
          className="input__fileInput"
          id={idInput}
          type="file"
          ref={input => {
            this.fileInput = input;
          }}
          accept=".doc, .docx, .pdf, .rtf, .odt"
          value={this.state.value}
          onInput={this.handleFile}
          name={this.props.name}
        />
        {
          !this.state.isLoaded ?
          [
            <label tabIndex="1" key="file-label" className="input__label" htmlFor={idInput} dangerouslySetInnerHTML={{ __html: fileLabel }} />,
            <span key="file-extensions" className="input__extensions">DOC, DOCX, PDF, RTF, ODT</span>
          ] :
          <div className="input__loadedFile">
            {
              this.fileInput.files[0] &&
              <span className="input__loadedFileName">{this.fileInput.files[0].name}</span>
            }
            <span role="button" tabIndex="1" className="input__deleteFile" onClick={this.removeFile}>удалить</span>
          </div>
        }
      </div>
    );
  }
}

export default FileInput;



// WEBPACK FOOTER //
// ./src/components/Input/FileInput.js